import * as _ from 'lodash';
import * as moment from 'moment';
import { randomColor } from 'randomcolor';

export default {
    title: 'Queue time consumption',
    chartSettings: {
        type: 'pie',
        options: {
            responsive: true,
            maintainAspectRatio:false,
            legend: {
                display: false
            },
            tooltips: {
                callbacks: {
                    title: function(tooltipItem, data, c) {
                        return "Queue: " + data.labels[tooltipItem[0].index];
                    },
                    label: function(tooltipItem, data, c) {
                        let tt = tooltipItem;
                        let value = data.datasets[tt.datasetIndex].data[tt.index];
                        return "Time consumed: " + moment.unix(value).utc().format("HH:mm:ss")
                    }
                }
            }
        },
        data: {
            backgroundColor: 'red'
        }
    },
    mapData(data){
        return {
            labels: _.map(data, 'queue'),
            datasets: [{
                backgroundColor: _.map(data, () => randomColor()),
                label: () => {
                    return 'test'
                },
                data: _.map(data, 'duration')
            }]
        }
    },
    fetchDataFn: 'getTimeConsumingByQueue'

}


// WEBPACK FOOTER //
// ./src/components/stats/charts/commonWidgetSettings/queuesTimeConsumption.settings.js